import ProfileSettings from "@/components/ProfileSettings";
export default function DriverProfile() {
  return <ProfileSettings index="05" />;
}
